/* esm.sh - esbuild bundle(@internetarchive/modal-manager@2.0.1) esnext production */
var h=class{constructor(e){var i,s,o,a,n,d,l;this.title=e?.title,this.subtitle=e?.subtitle,this.headline=e?.headline,this.message=e?.message,this.headerColor=(i=e?.headerColor)!==null&&i!==void 0?i:"#55A183",this.bodyColor=(s=e?.bodyColor)!==null&&s!==void 0?s:"#f5f5f7",this.showProcessingIndicator=(o=e?.showProcessingIndicator)!==null&&o!==void 0?o:!1,this.processingImageMode=(a=e?.processingImageMode)!==null&&a!==void 0?a:"complete",this.showCloseButton=(n=e?.showCloseButton)!==null&&n!==void 0?n:!0,this.showHeaderLogo=(d=e?.showHeaderLogo)!==null&&d!==void 0?d:!0,this.closeOnBackdropClick=(l=e?.closeOnBackdropClick)!==null&&l!==void 0?l:!0}};import{__awaiter as B,__decorate as L}from"/v135/tslib@2.8.1/esnext/tslib.mjs";import{LitElement as X,html as Y,css as g}from"/v135/lit@2.8.0/esnext/lit.mjs";import{property as C,customElement as q,query as G}from"/v135/lit@2.8.0/esnext/decorators.js";function*w(t=document.activeElement){t!=null&&(yield t,"shadowRoot"in t&&t.shadowRoot&&t.shadowRoot.mode!=="closed"&&(yield*w(t.shadowRoot.activeElement)))}function x(){return[...w()].pop()}var M=new WeakMap;function $(t){let e=M.get(t);return e||(e=window.getComputedStyle(t,null),M.set(t,e)),e}function R(t){if("checkVisibility"in t&&typeof t.checkVisibility=="function")return t.checkVisibility({checkOpacity:!1,checkVisibilityCSS:!0});let e=$(t);return e.visibility!=="hidden"&&e.display!=="none"}function _(t){let e=$(t),{overflowY:i,overflowX:s}=e;return i==="scroll"||s==="scroll"?!0:i!=="auto"||s!=="auto"?!1:t.scrollHeight>t.clientHeight&&i==="auto"||t.scrollWidth>t.clientWidth&&s==="auto"}function P(t){let e=t.tagName.toLowerCase(),i=Number(t.getAttribute("tabindex"));return t.hasAttribute("tabindex")&&(isNaN(i)||i<=-1)||t.hasAttribute("disabled")||t.closest("[inert]")||e==="input"&&t.getAttribute("type")==="radio"&&!t.hasAttribute("checked")||!R(t)?!1:(e==="audio"||e==="video")&&t.hasAttribute("controls")||t.hasAttribute("tabindex")||t.hasAttribute("contenteditable")&&t.getAttribute("contenteditable")!=="false"||["button","input","select","textarea","a","audio","video","summary","iframe"].includes(e)?!0:_(t)}function Z(t,e){var i;return((i=t.getRootNode({composed:!0}))===null||i===void 0?void 0:i.host)!==e}function y(t){let e=new WeakMap,i=[];function s(o){if(o instanceof Element){if(o.hasAttribute("inert")||o.closest("[inert]")||e.has(o))return;e.set(o,!0),!i.includes(o)&&P(o)&&i.push(o),o instanceof HTMLSlotElement&&Z(o,t)&&o.assignedElements({flatten:!0}).forEach(a=>{s(a)}),o.shadowRoot!==null&&o.shadowRoot.mode==="open"&&s(o.shadowRoot)}for(let a of Array.from(o.children))s(a)}return s(t),i.sort((o,a)=>{let n=Number(o.getAttribute("tabindex"))||0;return(Number(a.getAttribute("tabindex"))||0)-n})}var b=[],p=class{constructor(e){this.isExternalActivated=!1,this.tabDirection="forward",this.currentFocus=null,this.previousFocus=null,this.handleFocusIn=()=>{this.isActive()&&this.checkFocus()},this.handleKeyDown=i=>{var s;if(i.key!=="Tab"||this.isExternalActivated||!this.isActive())return;let o=x();if(this.previousFocus=o,this.previousFocus&&this.possiblyHasTabbableChildren(this.previousFocus))return;i.shiftKey?this.tabDirection="backward":this.tabDirection="forward";let a=y(this.element),n=a.findIndex(l=>l===o);this.previousFocus=this.currentFocus;let d=this.tabDirection==="forward"?1:-1;for(;;){n+d>=a.length?n=0:n+d<0?n=a.length-1:n+=d,this.previousFocus=this.currentFocus;let l=a[n];if(this.tabDirection==="backward"&&this.previousFocus&&this.possiblyHasTabbableChildren(this.previousFocus)||l&&this.possiblyHasTabbableChildren(l))return;i.preventDefault(),this.currentFocus=l,(s=this.currentFocus)===null||s===void 0||s.focus({preventScroll:!1});let f=[...w()];if(f.includes(this.currentFocus)||!f.includes(this.previousFocus))break}setTimeout(()=>this.checkFocus())},this.handleKeyUp=()=>{this.tabDirection="forward"},this.element=e,this.elementsWithTabbableControls=["iframe"]}activate(){b.push(this.element),document.addEventListener("focusin",this.handleFocusIn),document.addEventListener("keydown",this.handleKeyDown),document.addEventListener("keyup",this.handleKeyUp)}deactivate(){b=b.filter(e=>e!==this.element),this.currentFocus=null,document.removeEventListener("focusin",this.handleFocusIn),document.removeEventListener("keydown",this.handleKeyDown),document.removeEventListener("keyup",this.handleKeyUp)}isActive(){return b[b.length-1]===this.element}activateExternal(){this.isExternalActivated=!0}deactivateExternal(){this.isExternalActivated=!1}checkFocus(){if(this.isActive()&&!this.isExternalActivated){let e=y(this.element);if(!this.element.matches(":focus-within")){let i=e[0],s=e[e.length-1],o=this.tabDirection==="forward"?i:s;typeof o?.focus=="function"&&(this.currentFocus=o,o.focus({preventScroll:!1}))}}}possiblyHasTabbableChildren(e){return this.elementsWithTabbableControls.includes(e.tagName.toLowerCase())||e.hasAttribute("controls")}};import{__decorate as T}from"/v135/tslib@2.8.1/esnext/tslib.mjs";import{LitElement as W,html as u,css as r,nothing as K}from"/v135/lit@2.8.0/esnext/lit.mjs";import{property as U,customElement as V}from"/v135/lit@2.8.0/esnext/decorators.js";import"/v135/@internetarchive/ia-activity-indicator@0.0.6/esnext/ia-activity-indicator.mjs";import"/v135/@internetarchive/icon-close@1.3.4/esnext/icon-close.mjs";import{html as N}from"/v135/lit@2.8.0/esnext/lit.mjs";var E=N`
  <svg
    class="ia-logo"
    viewBox="0 0 27 30"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="logoTitleID logoDescID"
  >
    <title id="logoTitleID">Internet Archive logo</title>
    <desc id="logoDescID">
      A line drawing of the Internet Archive headquarters building façade.
    </desc>
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <mask id="mask-2" class="fill-color">
        <path
          d="M26.6666667,28.6046512 L26.6666667,30 L0,30 L0.000283687943,28.6046512 L26.6666667,28.6046512 Z M25.6140351,26.5116279 L25.6140351,28.255814 L1.05263158,28.255814 L1.05263158,26.5116279 L25.6140351,26.5116279 Z M3.62469203,7.6744186 L3.91746909,7.82153285 L4.0639977,10.1739544 L4.21052632,13.9963932 L4.21052632,17.6725617 L4.0639977,22.255044 L4.03962296,25.3421929 L3.62469203,25.4651163 L2.16024641,25.4651163 L1.72094074,25.3421929 L1.55031755,22.255044 L1.40350877,17.6970339 L1.40350877,14.0211467 L1.55031755,10.1739544 L1.68423854,7.80887484 L1.98962322,7.6744186 L3.62469203,7.6744186 Z M24.6774869,7.6744186 L24.9706026,7.82153285 L25.1168803,10.1739544 L25.2631579,13.9963932 L25.2631579,17.6725617 L25.1168803,22.255044 L25.0927809,25.3421929 L24.6774869,25.4651163 L23.2130291,25.4651163 L22.7736357,25.3421929 L22.602418,22.255044 L22.4561404,17.6970339 L22.4561404,14.0211467 L22.602418,10.1739544 L22.7369262,7.80887484 L23.0420916,7.6744186 L24.6774869,7.6744186 Z M9.94042303,7.6744186 L10.2332293,7.82153285 L10.3797725,10.1739544 L10.5263158,13.9963932 L10.5263158,17.6725617 L10.3797725,22.255044 L10.3556756,25.3421929 L9.94042303,25.4651163 L8.47583122,25.4651163 L8.0362015,25.3421929 L7.86556129,22.255044 L7.71929825,17.6970339 L7.71929825,14.0211467 L7.86556129,10.1739544 L8.00005604,7.80887484 L8.30491081,7.6744186 L9.94042303,7.6744186 Z M18.0105985,7.6744186 L18.3034047,7.82153285 L18.449948,10.1739544 L18.5964912,13.9963932 L18.5964912,17.6725617 L18.449948,22.255044 L18.425851,25.3421929 L18.0105985,25.4651163 L16.5460067,25.4651163 L16.1066571,25.3421929 L15.9357367,22.255044 L15.7894737,17.6970339 L15.7894737,14.0211467 L15.9357367,10.1739544 L16.0702315,7.80887484 L16.3753664,7.6744186 L18.0105985,7.6744186 Z M25.6140351,4.53488372 L25.6140351,6.97674419 L1.05263158,6.97674419 L1.05263158,4.53488372 L25.6140351,4.53488372 Z M13.0806755,0 L25.9649123,2.93331338 L25.4484139,3.8372093 L0.771925248,3.8372093 L0,3.1041615 L13.0806755,0 Z"
          id="path-1"
        ></path>
      </mask>
      <use class="fill-color" xlink:href="#path-1"></use>
      <g mask="url(#mask-2)" class="fill-color">
        <path
          d="M0,0 L26.6666667,0 L26.6666667,30 L0,30 L0,0 Z"
          id="swatch"
        ></path>
      </g>
    </g>
  </svg>
`;var k=class extends W{constructor(){super(...arguments),this.config=new h}render(){return u`
      <div class="modal-wrapper">
        <div class="modal-container">
          <header style="background-color: ${this.config.headerColor}">
            ${this.config.showCloseButton?this.closeButtonTemplate:""}
            ${this.config.showHeaderLogo?u`<div class="logo-icon">${E}</div>`:K}
            ${this.config.title?u`<h1 class="title">${this.config.title}</h1>`:""}
            ${this.config.subtitle?u`<h2 class="subtitle">${this.config.subtitle}</h2>`:""}
          </header>
          <section
            class="modal-body"
            style="background-color: ${this.config.bodyColor}"
          >
            <div class="content">
              <div
                class="processing-logo ${this.config.showProcessingIndicator?"":"hidden"}"
              >
                <ia-activity-indicator
                  .mode=${this.config.processingImageMode}
                ></ia-activity-indicator>
              </div>
              ${this.config.headline?u` <h1 class="headline">${this.config.headline}</h1> `:""}
              ${this.config.message?u` <p class="message">${this.config.message}</p> `:""}

              <div class="slot-container">
                <slot> </slot>
              </div>
            </div>
          </section>
        </div>
      </div>
    `}handleCloseButton(e){if(e.preventDefault(),e.type==="keydown"&&e.key!==" "&&e.key!=="Enter")return;let i=new Event("closeButtonPressed");this.dispatchEvent(i)}get closeButtonTemplate(){return u`
      <button
        type="button"
        class="close-button"
        @click=${this.handleCloseButton}
        @keydown=${this.handleCloseButton}
      >
        <ia-icon-close></ia-icon-close>
      </button>
    `}static get styles(){let e=r`var(--modalLogoSize, 6.5rem)`,i=r`var(--processingImageSize, 7.5rem)`,s=r`var(--modalCornerRadius, 1rem)`,o=r`var(--modalBorder, 2px solid black)`,a=r`var(--modalBottomMargin, 2.5rem)`,n=r`var(--modalTopMargin, 5rem)`,d=r`var(--modalHeaderBottomPadding, 0.5em)`,l=r`var(--modalBottomPadding, 2rem)`,f=r`var(--modalScrollOffset, 5px)`,A=r`var(--modalTitleFontSize, 1.8rem)`,F=r`var(--modalSubtitleFontSize, 1.4rem)`,S=r`var(--modalHeadlineFontSize, 1.6rem)`,z=r`var(--modalMessageFontSize, 1.4rem)`,H=r`var(--modalTitleLineHeight, normal)`,D=r`var(--modalSubtitleLineHeight, normal)`,O=r`var(--modalHeadlineLineHeight, normal)`,I=r`var(--modalMessageLineHeight, normal)`;return r`
      .processing-logo {
        margin: auto;
        width: ${i};
        height: ${i};
      }

      .processing-logo.hidden {
        height: 1rem;
      }

      .processing-logo.hidden ia-activity-indicator {
        display: none;
      }

      .modal-wrapper {
        outline: none;
      }

      .modal-container {
        border-radius: ${s};
        width: 100%;
        margin-top: ${n};
      }

      header {
        position: relative;
        background-color: #36a483;
        color: white;
        border-radius: calc(${s}) calc(${s}) 0 0;
        border: ${o};
        border-bottom: 0;
        text-align: center;
        padding-bottom: ${d};
      }

      .title {
        margin: 0;
        padding: 0;
        font-size: ${A};
        font-weight: bold;
        line-height: ${H};
      }

      .subtitle {
        margin: 0;
        padding: 0;
        font-weight: normal;
        padding-top: 0;
        font-size: ${F};
        line-height: ${D};
      }

      .modal-body {
        background-color: #f5f5f7;
        border-radius: 0 0 calc(${s}) calc(${s});
        border: ${o};
        border-top: 0;
        padding: 0 1rem calc(${l} - ${f}) 1rem;
        color: #333;
        margin-bottom: 2.5rem;
        min-height: 5rem;
      }

      .content {
        overflow-y: auto;
        max-height: calc(100vh - (16.5rem + ${a}));
        min-height: 5rem;
        padding: 0 0 calc(${f}) 0;
      }

      .headline {
        font-size: ${S};
        font-weight: bold;
        text-align: center;
        line-height: ${O};
        margin: 0;
        padding: 0;
      }

      .message {
        margin: 1rem 0 0 0;
        text-align: center;
        font-size: ${z};
        line-height: ${I};
      }

      .logo-icon {
        border-radius: 100%;
        border: 3px solid #fff;
        box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.18),
          0 2px 2px 0 rgba(0, 0, 0, 0.08);
        width: ${e};
        height: ${e};
        margin: -2.9rem auto 0.5rem auto;
        background-color: black;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .logo-icon svg {
        width: calc(${e} * 0.65);
        height: calc(${e} * 0.65);
      }

      .logo-icon svg .fill-color {
        fill: white;
      }

      .logo-icon svg .stroke-color {
        stroke: red;
      }

      .close-button {
        position: absolute;
        right: 1.2rem;
        top: 1.2rem;
        width: 2rem;
        height: 2rem;
        border-radius: 100%;
        border: 0;
        padding: 0;
        cursor: pointer;
        background-color: white;
        box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.18),
          0 4px 4px 0 rgba(0, 0, 0, 0.08);
      }

      .sr-only {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        border: 0;
      }

      slot::slotted(.sr-only) {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        border: 0;
      }
    `}};T([U({type:Object})],k.prototype,"config",void 0);k=T([V("modal-template")],k);import{throttle as j}from"/v135/throttle-debounce@5.0.2/esnext/throttle-debounce.mjs";var c;(function(t){t.Open="open",t.Closed="closed"})(c||(c={}));var v=class{constructor(e){this.windowResizeThrottler=j(100,this.updateModalContainerHeight,{noLeading:!1,noTrailing:!1}).bind(this),this.modalManager=e}handleModeChange(e){switch(e){case c.Open:this.startResizeListener(),this.stopDocumentScroll();break;case c.Closed:this.stopResizeListener(),this.resumeDocumentScroll();break}}updateModalContainerHeight(){this.modalManager.style.setProperty("--containerHeight",`${window.innerHeight}px`)}stopDocumentScroll(){document.body.classList.add("modal-manager-open")}resumeDocumentScroll(){document.body.classList.remove("modal-manager-open")}startResizeListener(){window.addEventListener("resize",this.windowResizeThrottler)}stopResizeListener(){window.removeEventListener("resize",this.windowResizeThrottler)}};var m=class extends X{constructor(){super(...arguments),this.mode=c.Closed,this.hostBridge=new v(this),this.modal=new p(this),this.closeOnBackdropClick=!0}firstUpdated(){return B(this,void 0,void 0,function*(){yield new Promise(e=>setTimeout(e,0)),this.closeOnBackdropClick&&this.addEventListener("keydown",e=>{e.key==="Escape"&&this.backdropClicked()})})}disconnectedCallback(){super.disconnectedCallback(),this.modal.deactivate()}render(){return Y`
      <div class="container">
        <div class="backdrop" @click=${this.backdropClicked}></div>
        <modal-template
          @closeButtonPressed=${this.closeButtonPressed}
          tabindex="-1"
        >
          ${this.customModalContent}
        </modal-template>
      </div>
    `}getMode(){return this.mode}closeModal(){this.mode=c.Closed,this.customModalContent=void 0,this.modalTemplate.config=new h,this.modal.deactivate()}callUserClosedModalCallback(){let e=this.userClosedModalCallback;this.userClosedModalCallback=void 0,e&&e()}showModal(e){return B(this,void 0,void 0,function*(){this.closeOnBackdropClick=e.config.closeOnBackdropClick,this.userClosedModalCallback=e.userClosedModalCallback,this.modalTemplate.config=e.config,this.customModalContent=e.customModalContent,this.mode=c.Open,yield this.modalTemplate.updateComplete,this.modalTemplate.focus(),this.modal.activate()})}updated(e){e.has("mode")&&this.handleModeChange()}backdropClicked(){this.closeOnBackdropClick&&(this.closeModal(),this.callUserClosedModalCallback())}handleModeChange(){this.hostBridge.handleModeChange(this.mode),this.emitModeChangeEvent()}emitModeChangeEvent(){let e=new CustomEvent("modeChanged",{detail:{mode:this.mode}});this.dispatchEvent(e)}closeButtonPressed(){this.closeModal(),this.callUserClosedModalCallback()}static get styles(){let e=g`var(--modalBackdropColor, rgba(10, 10, 10, 0.9))`,i=g`var(--modalBackdropZindex, 1000)`,s=g`var(--modalWidth, 32rem)`,o=g`var(--modalMaxWidth, 95%)`,a=g`var(--modalZindex, 2000)`;return g`
      .container {
        width: 100%;
        height: 100%;
      }

      .backdrop {
        position: fixed;
        top: 0;
        left: 0;
        background-color: ${e};
        width: 100%;
        height: 100%;
        z-index: ${i};
      }

      modal-template {
        outline: 0;
        position: fixed;
        top: 0;
        left: 50%;
        transform: translate(-50%, 0);
        z-index: ${a};
        width: ${s};
        max-width: ${o};
      }
    `}};L([C({type:String,reflect:!0})],m.prototype,"mode",void 0);L([C({type:Object})],m.prototype,"customModalContent",void 0);L([C({type:Object})],m.prototype,"hostBridge",void 0);L([G("modal-template")],m.prototype,"modalTemplate",void 0);m=L([q("modal-manager")],m);export{h as ModalConfig,m as ModalManager,v as ModalManagerHostBridge,c as ModalManagerMode,k as ModalTemplate};
//# sourceMappingURL=modal-manager.mjs.map